import Vue from 'vue'
import AppNav from './AppNav.vue'
import AppS from './AppS.vue'
import WPAPI from 'wpapi'

Vue.config.productionTip = false
Vue.prototype.$wp = new WPAPI({endpoint: 'https://skmetal.anvetogroup.com/wp-json'})

new Vue({
  render: h => h(AppNav),
}).$mount('#app8')

new Vue({
  render: h => h(AppS),
}).$mount('#app9')
